import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLabel,
  FieldLegend,
  FieldSeparator,
  FieldSet,
} from "@/client/components/shad/field";
import { withForm } from "../../form-context";
import { skopaPlatformFormOptions } from "../shared";
import { PositionFields } from "../../components/PositionFields";
import { Switch } from "@/client/components/shad/switch";

export const PositionBlock = withForm({
  ...skopaPlatformFormOptions,
  render: function Render({ form }) {
    return (
      <FieldSet>
        <FieldLegend>Platform location</FieldLegend>
        <FieldDescription>
          This is a short description describing the form
        </FieldDescription>

        <FieldGroup>
          <Field>
            <form.AppField name="enableGps">
              {(field) => {
                return (
                  <field.SwitchField
                    trueLabel="GPS enabled"
                    falseLabel="GPS disabled"
                  />
                );
              }}
            </form.AppField>
          </Field>

          <FieldSeparator />

          <Field>
            <PositionFields form={form} fields="position" />
          </Field>

          <Field orientation="horizontal">
            <Field>
              <div className="max-w-32">
                <form.AppField name="headingDeg">
                  {(field) => <field.NumberSelectField label="Heading" />}
                </form.AppField>
              </div>
              <FieldDescription>Optional heading in degrees</FieldDescription>
            </Field>
            <Field>
              <div className="max-w-32">
                <form.AppField name="elevationM">
                  {(field) => (
                    <field.NumberSelectField
                      label="Elevation"
                      min={-1000}
                      max={1e5}
                    />
                  )}
                </form.AppField>
              </div>
              <FieldDescription>Optional elevation in metres</FieldDescription>
            </Field>
          </Field>
        </FieldGroup>
      </FieldSet>
    );
  },
});
